<div class="calendar-app col-sm-12 p-0 row m-0">
  <div class="calendar-app__body col-sm-9 p-0">
    <div class="row m-0 d-flex justify-content-between border-left" style="height: 55px;background: #fff">
      <div class="ml-1 d-flex align-items-center" style="flex-grow: 2">
        <div class="col-sm-5 p-0 mr-2 ml-1">
<!--          <div class="d-flex p-0 align-items-center">-->
<!--            <label class="col-sm-4 p-0 text-truncate m-0 ml-2 font-weight-bold">Kiểu vấn đề</label>-->
            <select  class="form-control form-control-sm col-sm-12" >
              <option value="">Chọn kiểu vấn đề</option>
              <option *ngFor="let tracker of trackers" [value]="tracker.id">
                {{tracker.name}}
              </option>
            </select>
<!--          </div>-->
        </div>
        <div class="col-sm-5 p-0 mr-2">
<!--          <div class="d-flex p-0 align-items-center">-->
<!--            <label class="col-sm-4 p-0 text-truncate m-0 ml-3 font-weight-bold">Trạng thái</label>-->
            <select  class="form-control form-control-sm col-sm-12" >
              <option value="">Chọn trạng thái</option>
              <option *ngFor="let status of statuses" [value]="status.id">
                {{status.name}}
              </option>
            </select>
<!--          </div>-->
        </div>
        <div class="col-sm-1 p-0">
          <button type="button" class="btn btn-light btn-sm bg-white">
            <i style="font-size: 20px" class="fa fa-filter text-primary " aria-hidden="true"></i>
          </button>
        </div>
        <!--        <button [hidden]="!viewFormCalendar" (click)="toogleViewForm()" type="button"-->
        <!--                class="btn btn-primary button-custom-calendar w-100 mr-1" title="Lưu">-->
        <!--          <i class="fa fa-arrow-left"></i>-->
        <!--        </button>-->
        <!--        <button (click)="createEvent()" type="button" class="btn btn-primary button-custom-calendar w-100 mr-1"-->
        <!--                title="Tạo sự kiện">-->
        <!--          <i class="fa fa-plus "></i>-->
        <!--        </button>-->
        <!--        <button [hidden]="!disableSave || !viewFormCalendar" (click)="onSaveFormCalendar()" type="button"-->
        <!--                class="btn btn-primary button-custom-calendar w-100 mr-1" title="Lưu">-->
        <!--          <i class="fa fa-save "></i>-->
        <!--        </button>-->
        <!--        <button [hidden]="!disableRemove || !viewFormCalendar" (click)="onRemoveFormCalendar($event)" type="button"-->
        <!--                class="btn btn-primary button-custom-calendar w-100 mr-1" title="Xóa">-->
        <!--          <i class="fa fa-trash "></i>-->
        <!--        </button>-->
        <!--                <button (click)="onToday()" [ngClass]="{'btn-light': !isToday}" type="button"-->
        <!--                        class="btn btn-primary button-custom-calendar w-100 mr-1">Hôm nay-->
        <!--                </button>-->
      </div>
      <div class="mr-1 d-flex align-items-center justify-content-end" style="flex-grow: 1">

        <i (click)="onPrev()" class="fa fa-chevron-left message-chat__action mr-1"></i>
        <div class="" style="font-size: 15px;font-weight: 400;line-height: 18px"> {{viewTitle || ''}}
        </div>
        <i (click)="onNext()" class="fa fa-chevron-right message-chat__action ml-1 mr-1"></i>
        <button (click)="onToday();" [ngClass]="{'btn-light': !isToday}" type="button"
                class="btn btn-primary button-calendar ml-1 mr-1">Hôm nay
        </button>
        <button [ngClass]="{'btn-light': isToday}" type="button"
                class="btn btn-primary button-calendar ml-1 mr-1">Tuần
        </button>

        <!--        <div class="btn-group mt-1 ml-1">-->
        <!--          <button type="button" class="btn btn-primary button-calendar dropdown-toggle" data-toggle="dropdown"-->
        <!--                  aria-haspopup="true" aria-expanded="false">-->
        <!--            {{calendarListType}}-->
        <!--          </button>-->
        <!--          <div class="dropdown-menu">-->
        <!--            <a class="dropdown-item" *ngFor="let type of viewTypes" (click)="changeView(type)"-->
        <!--               href="javascript:;">{{type.name}}</a>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <full-calendar
      #fullcalendar
      *ngIf='calendarVisible'
      [options]='calendarOptions'></full-calendar>

    <div class="calendar-popover" id="template-calendar-popover">
      <div class="mb-2">
        <span class="badge-ticket badge p-1 mr-2" [ngClass]="calendarItemsView?.tracker_name | badgeTracker">{{ '#' + calendarItemsView?.tracker_name+ ' ' +calendarItemsView?.id}}</span>
      </div>
      <div class="popover-message mb-2 f-11"><span class="font-weight-bold text-primary">{{calendarItemsView?.subject || '' | truncate : 128}} </span></div>
      <div class="popover-message mb-2 f-11">Trạng thái:
        <span class="badge-ticket badge p-1 mr-2" [ngClass]="calendarItemsView?.status_name | badgeStatus">
            {{calendarItemsView?.status_name }}
          </span>
      </div>
      <div class="popover-message mb-2 f-11">Bắt đầu: <span>{{calendarItemsView?.start_date | date: 'dd/MM/yyyy'}}</span></div>
      <div class="popover-message mb-2 f-11">Kết thúc:  <span>{{calendarItemsView?.due_date | date: 'dd/MM/yyyy'}}</span></div>
      <div class="popover-message mb-2 f-11">Phân công:  <span class="font-weight-bold text-primary">{{calendarItemsView?.assigned[1]}} </span></div>
    </div>

    <!--    <app-calendar-form [hidden]="!viewFormCalendar"-->
    <!--                       (onView)="viewFormCalendar=true"-->
    <!--                       [dataEvent]="events" [id]="uuidForm"-->
    <!--                       (onRemove)="onDisableRemove($event)"-->
    <!--                       (onSave)="onDisableSave($event)"-->
    <!--                       (onReload)="reloadEvent($event)"-->
    <!--                       (onBack)="onHideViewDetails($event)"></app-calendar-form>-->
  </div>

  <div class="calendar-app__nav col-sm-3  p-0">
    <div class="mt-0">
      <div class="font-weight-bold p-2 mx-0 mb-0 d-flex align-items-center border-bottom text-uppercase" role="alert"
           style="height: 56px;color: #1c9dea;">
        <i style="font-size: 18px;" class="fa fa-calendar-o pr-2" aria-hidden="true"></i>
        Sự kiện
        <i class="fa fa-chevron-l message-chat__action mr-1">{{listEvents.length}}</i>

      </div>
      <calendar-widget-today [eventsList]="listEvents" (onChange)="reloadEvents()" (listEvent)="setlistEvents($event)"></calendar-widget-today>
    </div>
  </div>
</div>
